/**
 * Stytch Email OTP Authentication Hooks (React Version)
 *
 * These hooks use the Stytch Next.js headless client.
 *
 */
import { getStytchClient } from './../client/headless-client';
// ============================================================================
// Hooks
// ============================================================================
/**
 * Hook to send discovery email OTP
 * Does not require organization - works with discovery flow
 */
export function useSendDiscoveryEmailOTP() {
    const stytch = getStytchClient();
    return async (email_address, options) => {
        try {
            if (!stytch) {
                return {
                    success: false,
                    error: 'Stytch client not ready',
                    data: null,
                };
            }
            const params = {
                email_address,
            };
            if (options?.login_template_id) {
                params.login_template_id = options.login_template_id;
            }
            if (options?.locale) {
                params.locale = options.locale;
            }
            const result = await stytch.otps.email.discovery.send(params);
            return {
                success: true,
                data: result,
            };
        }
        catch (error) {
            const stytchError = error;
            return {
                success: false,
                error: stytchError.error_message || stytchError.message || 'Failed to send discovery OTP',
                data: error,
            };
        }
    };
}
/**
 * Hook to authenticate discovery email OTP
 * Returns intermediate session and discovered organizations
 */
export function useAuthenticateDiscoveryEmailOTP() {
    const stytch = getStytchClient();
    return async (email_address, code) => {
        try {
            if (!stytch) {
                return {
                    success: false,
                    error: 'Stytch client not ready',
                    data: null,
                };
            }
            const result = await stytch.otps.email.discovery.authenticate({
                email_address,
                code,
            });
            return {
                success: true,
                intermediate_session_token: result.intermediate_session_token,
                email_address: result.email_address,
                discovered_organizations: result.discovered_organizations,
                data: result,
            };
        }
        catch (error) {
            const stytchError = error;
            return {
                success: false,
                error: stytchError.error_message || stytchError.message || 'Failed to authenticate discovery OTP',
                data: error,
            };
        }
    };
}
